<template>
  <div class="content-main">

    <van-popup v-model="subscribeLoading" class="pop-loading">
      <div class="loading">
        <span>正在拼命加载中，请稍等片刻～</span>
        <van-loading type="spinner" />
      </div>
    </van-popup>

    <van-popup v-model="showFocusQrcode" class="pop-focus" position="center" :close-on-click-overlay="false">
      <div class="ptitle">提示</div>
      <img class="qrcode" src="https://static.huiyiji520.com/qrcode-garden_special_focus-1573426299.jpeg">
      <div class="hints">
        <div class="hint">↑长按识别上方二维码</div>
        <div class="hint">关注公众号：<span class="account">浪漫员Plus</span></div>
        <div class="hint">即可接收留言更新提醒</div>
      </div>
    </van-popup>

    <div class="shanzha">

      <div class="logo-and-wish flex-box">
        <img class="logo" :src="$store.state.favicon">
        <span>{{$store.state.siteSlogan}}</span>
      </div>

      <div class="message">

        <div class="info-input flex-box username">
          <div class="input-label">TA的名字</div>
          <input class="username-content" placeholder="请输入你的名字或暗号" v-model="username" />
          <div class="btn-subscribe" v-if="update == true && focus == false" @click="showFocusDialog()">关注</div>
          <div class="btn-subscribed" v-if="update == true && focus == true" @click="unsubscribeName()">取消关注</div>
        </div>

        <div class="btn-submit" @click="checkMsg()">查看留言</div>

      </div>

      <div v-if="update" class="postcard-rule-v2 flex-box" @click="goPostcardExample()">
        <!-- <span class="rule-dot">•</span> -->
        <!-- <span class="gesture-right">👉</span><span class="rule-text">点击查看纸质信实拍图</span> -->
        <span class="gesture-right">👉</span><span class="rule-text">我们谈一场3天就分手的恋爱吧</span>
      </div>

      <div class="infos" v-if="update">
        <div class="hint">给你的留言</div>

        <div class="info-item" v-for="(info, index) in pendings" :key="info.id">
          <div class="userinfo flex-box">
            <div class="headimg-nickname flex-box">
              <img v-if="info.anonymous" class="headimg" :src="info.headimgurl">
              <img v-if="!info.anonymous" class="headimg" src="https://static.huiyiji520.com/icon-no-gender-a5d5ae.png">
              <div v-if="info.anonymous" class="nickname">{{info.nickname}}</div>
              <div v-if="!info.anonymous" class="nickname">用户{{info.aliasname}}</div>
            </div>
            <div class="date">{{info.date}}</div>
          </div>
          <div v-if="info.status == 5" class="info-content" style="white-space: pre-wrap;color:#f1b8af;">你提交的留言正在审核中，预计{{getAuditTimeCost()}}小时内完成审核。审核时间为早9:00～晚18:00。审核通过以后，留言内容自动公开。</div>
          <div v-if="info.status == 7" class="info-content" style="white-space: pre-wrap;color:#f1b8af;">你的留言存在不符合社区规范的内容，需修改。请修改留言内容，并重新提交审核。</div>
          <div class="switch-and-delete flex-box" v-if="info.own == 1 && info.status == 5">
            <div v-if="info.anonymous" class="box-switch flex-box" @click="switchMessageAnonymous(info.id, index)"><van-switch v-model="info.anonymous" inactive-color="#e2e2e2" size="13px"/>隐藏昵称</div>
            <div v-if="!info.anonymous" class="box-switch flex-box" @click="switchMessageAnonymous(info.id, index)"><van-switch v-model="info.anonymous" inactive-color="#e2e2e2" size="13px"/>公开昵称</div>
          </div>
          <div class="entry-modify flex-box" v-if="info.own == 1 && info.status == 7">
            <div class="box-modify flex-box" @click="modifyMsg(info.id)"><van-icon name="edit" />修改留言</div>
          </div>
        </div>

        <!-- <div class="infos-list"> -->
        <van-list
          v-show="!no_message"
          class = "infos-list"
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了~"
          @load="onLoad"
          :immediate-check="immediateCheck">

          <div class="info-item" v-for="(info, index) in infos" :key="info.id">
            <div class="userinfo flex-box">
              <div class="headimg-nickname flex-box">
                <img v-if="info.anonymous" class="headimg" :src="info.headimgurl">
                <img v-if="!info.anonymous" class="headimg" src="https://static.huiyiji520.com/icon-no-gender-a5d5ae.png">
                <div v-if="info.anonymous" class="nickname">{{info.nickname}}</div>
                <div v-if="!info.anonymous" class="nickname">用户{{info.aliasname}}</div>
              </div>
              <div class="date">{{info.date}}</div>
            </div>
            <div class="info-content" style="white-space: pre-wrap;">{{info.content}}</div>
            <div class="switch-and-delete flex-box" v-if="info.own == 1">
              <div v-if="info.anonymous" class="box-switch flex-box" @click="switchMessageAnonymous(info.id, index)"><van-switch v-model="info.anonymous" inactive-color="#e2e2e2" size="13px"/>隐藏昵称</div>
              <div v-if="!info.anonymous" class="box-switch flex-box" @click="switchMessageAnonymous(info.id, index)"><van-switch v-model="info.anonymous" inactive-color="#e2e2e2" size="13px"/>公开昵称</div>
              <div class="box-delete flex-box" @click="showDeleteDialog(info.id, index)"><van-icon name="delete" />删除</div>
            </div>
            <div class="feedback-more flex-box" v-if="info.own == 2">
              <div class="box-more flex-box" @click="showFeedbackAction(info.id, info.content)"><van-icon name="ellipsis" /></div>
            </div>
          </div>

        </van-list>
        <!-- </div> -->

        <div class="no-message" v-if="no_message">
          <div>暂时还没有人给你留言哦～</div>
          <div>不过没关系，你可以给TA留个言呀～</div>
        </div>
      </div>

    </div>

    <div class="btn-check flex-box" @click="goMessageCreate()"><div class="btn-txt flex-box"><div>创建</div><div>留言</div></div></div>
    <!-- <div class="btn-check flex-box" @click="goMessageCreate()" v-if="!has_my_msg"><div class="btn-txt flex-box"><div>创建</div><div>留言</div></div></div> -->

    <van-popup class="feedback-popup" v-model="showFeedbackPopup" position="bottom">
      <div class="title">留言内容：「 {{ feedbackPopTitle }}... 」</div>
      <div class="feedback-entries">
        <div class="item flex-box" @click="handleComplain()"><van-icon name="warn-o" />举报</div>
        <div class="item flex-box entry-shield" @click="showShieldDialog()"><van-icon name="delete" />屏蔽</div>
      </div>
    </van-popup>

    <van-popup class="subscribe-pay-popup" v-model="showSubscribePayPopup" position="bottom">
      <div class="title">添加特别关注（3元/1年）</div>
      <div class="intro">
        <div class="remark">* 设置特别关注以后，若该名字下面出现新留言，将会为你推送消息提醒。有效期一年。</div>
      </div>
      <div class="pay-confirm" @click="paySubscribe()">确认并支付</div>
    </van-popup>

    <van-tabbar v-model="tabActive" active-color="#f1b8af">
      <van-tabbar-item icon="wap-home" @click="goHome()">首页</van-tabbar-item>
      <van-tabbar-item icon="eye-o">看留言</van-tabbar-item>
      <van-tabbar-item icon="envelop-o" @click="goMessageCreate()">写留言</van-tabbar-item>
      <van-tabbar-item icon="manager-o" @click="goUserCenter()">个人中心</van-tabbar-item>
    </van-tabbar>

  </div>
</template>

<script>
import wx from 'weixin-js-sdk'
import { Toast, Dialog, Popup } from 'vant'

export default{
  data(){
    return {
      username: '',
      infos: [],
      pendings: [],
      update: false,
      no_message: false,
      next_page: 1,
      total_entries: 1,
      total_pages: 1,
      finished: false,
      loading: false,
      immediateCheck: false,
      showFeedbackPopup: false,
      feedbackPopTitle: '',
      feedbackInfoId: '',
      tabActive: 1,
      showSubscribePayPopup: false,
      subscribeLoading: false,
      focus: false,
      showFocusQrcode: false,
      submiting: false,
      has_my_msg: false
    }
  },
  methods: {
    handleRouter(path){
      this.$router.push(path)
    },
    goHome(){
      this.$router.replace("/")
    },
    goUserCenter(){
      this.$router.replace("/user_center")
    },
    onLoad() {
      // this.checkMsg()
      // console.log('onLoad hehe')
      this.loading = true
      this.getMsgs()
    },
    initReceiver(){
      if(this.$route.query.receiver){
        this.username = this.$route.query.receiver
        this.checkMsg()
      }
    },
    checkMsg(){
      if(this.username.length == 0){
        Toast('请输入你的名字或暗号')
        return
      }else if(this.loading){
        return
      }else{
        this.infos = []
        this.no_message = false
        this.next_page = 1
        this.total_entries = 1
        this.total_pages = 1
        this.finished = false
        this.loading = false
        this.onLoad()
        // console.log('this.loading: ' + this.loading + '  ;this.finished: ' + this.finished)
        // console.log('else check')
      }
    },
    getMsgs(){
      let openid = this.$store.state.userinfo.openid
      this.$api.get('/garden/get_msg_by_watchword', {watchword: this.username.trim(), openid: openid, page: this.next_page}, res => {
        if(res.code == 200){
          // this.infos = res.infos
          this.infos = this.infos.concat(res.infos)
          this.pendings = res.pendings
          this.focus = res.focus
          this.total_entries = res.paginate.total_entries
          this.next_page = this.next_page + 1
          this.total_pages = res.paginate.total_pages
          this.loading = false
          if(this.next_page > this.total_pages){
            this.finished = true
          }

          if(this.total_entries == 0){
            this.no_message = true
          }else{
            this.no_message = false
          }

          if(!this.update){
            this.update = true
          }

          if(res.has_my_msg == true){
            this.has_my_msg = true
          }

          // if(this.focus == true && this.$store.state.userinfo.subscribe == 0){
          //   this.showFocusQrcode = true
          // }

        }else{
          Toast(res.msg)
          this.update = false
          this.loading = false
        }
      })
    },
    switchMessageAnonymous(info_id, index){
      let openid = this.$store.state.userinfo.openid
      this.$api.get('/info/switch_anonymous_from_user', {info_id: info_id, openid: openid}, res => {
        if(res.code == 200){
          Toast('修改成功！')
        }
      })
    },
    showDeleteDialog(info_id, index){
      Dialog.confirm({
        title: '删除提醒',
        message: '是否要删除该内容，删除以后不可恢复'
      }).then(() => {
        // on confirm
        this.deleteMessage(info_id, index)
      }).catch(() => {
        // on cancel
      });
    },
    deleteMessage(info_id, index){
      let openid = this.$store.state.userinfo.openid
      this.$api.get('/info/delete_info_from_user', {info_id: info_id, openid: openid}, res => {
        if(res.code == 200){
          Toast('删除成功！')
          this.checkMsg()
        }
      })
    },
    showShieldDialog(){
      // console.log('showshielddialog')
      Dialog.confirm({
        title: '提示',
        message: '是否要屏蔽该留言，屏蔽以后你将看不到该条留言'
      }).then(() => {
        // on confirm
        this.shieldMessage(this.feedbackInfoId)
      }).catch(() => {
        // on cancel
        this.showFeedbackPopup = false
      });
    },
    shieldMessage(info_id){
      let openid = this.$store.state.userinfo.openid
      this.$api.get('/info/shield_info', {info_id: info_id, openid: openid}, res => {
        if(res.code == 200){
          Toast('已为你屏蔽该条留言')
          this.showFeedbackPopup = false
          this.checkMsg()
        }
      })
    },
    modifyMsg(info_id){
      // if(this.checkTimeForCreate()){
      //   this.handleRouter('/message_modify/' + info_id)
      // }else{
      //   Toast('留言修改时间为：早9点～晚24点\n其余时间仅可查看留言')
      // }
      this.handleRouter('/message_modify/' + info_id)
    },
    showFeedbackAction(id, content){
      this.feedbackPopTitle = content.slice(0, 15)
      this.feedbackInfoId = id
      this.showFeedbackPopup = true
    },
    hideFeedbackAction(){
      this.hideFeedbackPopup = false
    },
    showSubscribePayAction(){
      this.showSubscribePayPopup = true
      this.reportFocusBtnClick()
    },
    reportFocusBtnClick(){
      let openid = this.$store.state.userinfo.openid
      this.$api.post('/garden/report_focus_btn_click', {openid: openid}, res => {})
    },
    handleComplain(){
      this.handleRouter('/complain?id=' + this.feedbackInfoId)
    },
    goMessageCreate(){
      // if(this.$store.state.userinfo.silent == 1){
      //   Toast('系统正在维护中，暂时无法创建留言，仅可查看留言～')
      // }else if(this.checkTimeForCreate()){
      //   this.$router.replace("/message_create_combo")
      // }else{
      //   Toast('写留言时间为：早9点～晚24点\n其余时间仅可查看留言')
      // }
      if(this.$store.state.userinfo.silent == 1){
        Toast('系统正在维护中，暂时无法创建留言，仅可查看留言～')
      }else{
        this.$router.replace("/message_create_combo")
      }
    },
    getAuditTimeCost(){
      let date = new Date()
      let hour = date.getHours()
      if(hour > 8 && hour < 18){
        return "12"
      }else{
        return "24"
      }
    },
    checkTimeForCreate(){
      let date = new Date()
      let hour = date.getHours()
      if(hour > 8 && hour < 24){
        return true
      }else{
        return false
      }
    },
    wxConfigInit(){
      this.$api.get('/shanzhadao/get_wx_js_config_shanzhadao', {url: window.location.href}, res => {
        if(res.code == 200 && res.config){
          // alert('config: ' +JSON.stringify(res.config))
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: res.config.app_id, // 必填，公众号的唯一标识
            timestamp: res.config.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.config.noncestr, // 必填，生成签名的随机串
            signature: res.config.signature,// 必填，签名
            jsApiList: ['chooseWXPay', 'updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareTimeline', 'onMenuShareAppMessage'] // 必填，需要使用的JS接口列表
          });

          let share_nickname = this.$store.state.userinfo.nickname
          let share_title = `${share_nickname}给你写了一条留言～`
          let share_desc = '这里有你的故事'
          let share_link = this.$store.state.siteDomain
          let share_img = this.$store.state.userinfo.headimg

          let openid = this.$store.state.userinfo.openid
          let site_code = this.$store.state.siteCode
          let _this = this
          //分享到朋友圈（即将废弃）
          wx.onMenuShareTimeline({
            title: share_title, // 分享标题
            link: share_link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: share_img, // 分享图标
            success: function () {
              // 用户点击了分享后执行的回调函数
              _this.$hawutil.reportShare(site_code, openid)
            }
          })
          //分享给朋友（即将废弃）
          wx.onMenuShareAppMessage({
            title: share_title, // 分享标题
            desc: share_desc, // 分享描述
            link: share_link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: share_img, // 分享图标
            type: '', // 分享类型,music、video或link，不填默认为link
            dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
            success: function () {
              // 用户点击了分享后执行的回调函数
              _this.$hawutil.reportShare(site_code, openid)
            }
          })
          // //分享给朋友
          // wx.ready(function () {   //需在用户可能点击分享按钮前就先调用
          //   wx.updateAppMessageShareData({
          //     title: share_title, // 分享标题
          //     desc: share_desc, // 分享描述
          //     link: share_link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          //     imgUrl: share_img, // 分享图标
          //     success: function () {
          //       // 设置成功
          //       // _this.$hawutil.reportShare(site_code, openid)
          //     }
          //   })
          // });
          //
          // //分享到朋友圈
          // wx.ready(function () {      //需在用户可能点击分享按钮前就先调用
          //   wx.updateTimelineShareData({
          //     title: share_title, // 分享标题
          //     link: share_link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          //     imgUrl: share_img, // 分享图标
          //     success: function () {
          //       // 设置成功
          //       // _this.$hawutil.reportShare(site_code, openid)
          //     }
          //   })
          // });

        }
      })
    },
    paySubscribe(){
      this.subscribeLoading = true
      let openid = this.$store.state.userinfo.openid
      // alert("openid: " + this.$store.state.userinfo.openid)
      this.$api.post('/garden/pay_for_special_focus', {openid: openid, watchword: this.username.trim(), address: this.$store.state.siteCode}, res => {
        if(res.code == 200){
          // alert("pay res: " + JSON.stringify(res))
          this.subscribeLoading = false
          let _this = this
          wx.chooseWXPay({
            timestamp: res.timestamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
            nonceStr: res.nonceStr, // 支付签名随机串，不长于 32 位
            package: res.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
            signType: res.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
            paySign: res.paySign, // 支付签名
            success: function (payRes) {
              // 支付成功后的回调函数
              // alert("pay success: " + JSON.stringify(payRes));
              _this.showSubscribePayPopup = false
              _this.showFocusQrcode = true
              _this.focus = true
            },
            fail: function (payErr){
              // alert("pay fail: " + JSON.stringify(payErr));
              // alert("pay res: " + JSON.stringify(res))
            }
          })
        }else{
          this.subscribeLoading = false
          Toast(res.msg)
          // this.goMessageCheck()
        }
      })
    },
    showFocusDialog(){
      Dialog.confirm({
        title: '提示',
        message: '是否确认关注该名字，关注以后，若该名字下出现新留言，系统将为你推送消息提醒'
      }).then(() => {
        // on confirm
        this.submitFocusFree()
      }).catch(() => {
        // on cancel
      });
    },
    submitFocusFree(){
      if(this.submiting){
        return;
      }else{
        let submiting = true
        let openid = this.$store.state.userinfo.openid
        let subscribe = this.$store.state.userinfo.subscribe
        this.$api.post('/garden/submit_special_focus_free', {openid: openid, watchword: this.username.trim()}, res => {
          if(res.code == 200){
            if(subscribe == 0){
              this.showFocusQrcode = true
            }
            this.focus = true
          }else{
            Toast(res.msg)
          }
          this.submiting = false
        })
      }
    },
    unsubscribeName(){
      if(this.submiting){
        return;
      }else{
        let submiting = true
        let openid = this.$store.state.userinfo.openid
        this.$api.post('/garden/cancel_special_focus', {openid: openid, watchword: this.username.trim()}, res => {
          if(res.code == 200){
            this.focus = false
            Toast("取关成功！")
          }else{
            Toast(res.msg)
          }
          this.submiting = false
        })
      }
    },
    goPostcardExample(){
      // window.location.href = "https://mp.weixin.qq.com/s/QR69Ds0YQUR5TaRBL7pS2Q"
      window.location.href = "http://transfer.ypzhushou.com/api/couple/transfer_cp_article"
    }
  },
  mounted(){
    this.initReceiver()
    this.wxConfigInit()
  }
}
</script>

<style scoped>
.content-main{ min-height:100vh;background-color: #f8f8f8;color:#f1b8af;}
.shanzha{padding:15px;padding-top:25px;}
.logo-and-wish{font-size:17px;margin-bottom:20px;}
.logo{height:100px;width:100px;border-radius:100px;margin-right:25px;}
.message {background:#fff;padding:25px;}
.message .info-input{padding-bottom:15px;}
.message .username{border-bottom:1px solid #f1b8af;}
.message .input-label{font-size:14px;margin-right:10px;width:70px;}
.username .username-content{font-size:13px;flex-grow:1;border:none;color:#333;}
.message .info-input .btn-subscribe{font-size:12px;color:#fff;background:#f1b8af;padding:2px 5px;border-radius:5px;width:40px;}
.message .info-input .btn-subscribed{font-size:12px;color:#fff;background:#CCCCCC;padding:2px 5px;border-radius:5px;width:64px;}
.message .message-content{padding-top:15px;align-items:flex-start;}
.message-content .message-text{font-size:13px;flex-grow:1;border:none;color:#333;line-height:2.0;}
.switch-and-delete{justify-content:space-between;align-items:center;font-size:10px;color:#a0a0a0;margin-top:10px;}
.switch-and-delete .van-switch{margin-right:5px;}
.switch-and-delete .van-icon{margin-right:5px;}
.feedback-more{justify-content:flex-end;align-items:center;font-size:10px;color:#a0a0a0;margin-top:10px;}
.feedback-more .van-icon{margin-right:5px;color:#000;font-size:15px;font-weight:bold;}
.entry-modify{justify-content:flex-end;align-items:center;font-size:10px;color:#000;margin-top:10px;}
.entry-modify .van-icon{margin-right:5px;color:#000;font-size:15px;font-weight:bold;}
.btn-submit{background:#f1b8af;color:#fff;font-size:15px;font-weight:340;height:45px;line-height:45px;margin-top:10px;}
.btn-check{
  width:70px;height:70px;border-radius:70px;background:#f1b8af;position:fixed;
  bottom:80px;right:20px;color:#fff;justify-content:center;
}
.btn-txt{
  flex-direction: column;justify-content:center;border:1px solid #fff;width:56px;height:56px;
  border-radius:56px;border:1px solid #fff;font-size:14px;
}
*::-webkit-input-placeholder {color: #969799;font-size:12px;}
*:-moz-placeholder {/* FF 4-18 */color: #969799;font-size:12px;}
*::-moz-placeholder {/* FF 19+ */color: #969799;font-size:12px;}
*:-ms-input-placeholder {/* IE 10+ */color: #969799;font-size:12px;}
.infos{padding:25px;padding-bottom:120px;background:#fff;margin-top:10px;text-align:left;color:#f1b8af;}
.infos .hint{font-size:15px;border-bottom:1px solid #f1b8af;padding-bottom:10px;}
.infos .info-item{border-bottom:1px solid #f1b8af;padding-bottom:10px;color:#a0a0a0;}
.infos .no-message{font-size:15px;margin-top:15px;text-align:center;}
.infos .userinfo{padding:10px 0px;font-size:13px;justify-content:space-between;align-items:center;}
.infos .headimg{width:30px;height:30px;border-radius:30px;margin-right:10px;}
.infos .info-content{font-size:14px;color:#666;}
@media (max-height: 500px) {
  .btn-check {
    display: none;
  }
}
.feedback-popup{background:#fff;color:#333;font-size:10px;}
.feedback-popup .title{border-bottom:1px solid #f0f0f0;text-align:left;padding:10px;color:#666;}
.feedback-popup .feedback-entries{padding:0px 30px;}
.feedback-popup .item{padding:15px;font-size:14px;justify-content:center;align-items:center;}
.feedback-popup .item .van-icon{margin-right:5px;font-size:16px;font-weight:bold;color:#666;}
.feedback-popup .item.entry-shield{border-top:1px solid #f0f0f0;}

.subscribe-pay-popup{font-size:14px;padding:15px 0px 20px 0px;color:#737373;font-weight:normal;}
.subscribe-pay-popup .title{margin-bottom:12px;font-weight:bold;}
.subscribe-pay-popup .intro{
  background:#f7f7f7;padding:12px 10px;color:#737373;
  border-radius:5px;width:87%;margin:0 auto;margin-bottom:14px;text-align:left;
}
.subscribe-pay-popup .intro .price{font-size:16px;}
.subscribe-pay-popup .intro .remark{font-size:14px;}
.subscribe-pay-popup .pay-confirm{background:#eb8e80;color:#fbfbfb;padding:13px;border-radius:5px;width:87%;margin:0 auto;font-size:15px;}
.pop-loading{background:rgba(255,255,255,0);color:#fff;}
.pop-loading{font-size:13px;padding:20;}
.pop-loading .loading .van-loading{margin:0 auto;margin-bottom:15px;margin-top:30px;}

.pop-focus{color:#545454;width:70%;padding:25px 10px;border-radius:10px;}
.pop-focus .ptitle{font-size:20px;font-weight:bold;color:#f1b8af;}
.pop-focus .qrcode{width:140px;display:block;margin:0 auto;margin-top:10px;margin-bottom:10px;}
.pop-focus .account{font-weight:bold;color:#f1b8af;}
.pop-focus .hints{font-size:16px;}
.pop-focus .hints .hint{margin-bottom:8px;}

.postcard-rule-v2{background:#fff;margin-top:10px;margin-bottom:10px;height:35px;padding-left:10px;justify-content: flex-start;border-radius:6px;}
.postcard-rule-v2 .gesture-right{font-size:18px;margin-right:5px;}
.postcard-rule-v2 .rule-dot{color:#f39c12;margin-right:5px;font-size:30px;padding-bottom:5px;}
.postcard-rule-v2 .rule-text{color:#333;font-size:14px;font-weight:bold;}
</style>
